import { useState } from "react";
import { useImagesQuery, useDeleteImage } from "../../../lib/api/images.api";
import { ImageThumbnail } from "./ImageThumbnail";
import { ImageUploader } from "./ImageUploader";
import { ImageLightbox } from "./ImageLightbox";

interface ImageGalleryProps {
  readonly entityType: "task" | "event";
  readonly entityId: string;
  readonly hideUploader?: boolean;
}

export function ImageGallery({ entityType, entityId, hideUploader }: ImageGalleryProps) {
  const { data: images } = useImagesQuery(entityType, entityId);
  const deleteMutation = useDeleteImage();
  const [fullscreenId, setFullscreenId] = useState<string | null>(null);

  const hasImages = images && images.length > 0;

  return (
    <div className="space-y-1.5">
      {hasImages && (
        <div className="flex flex-wrap gap-2">
          {images.map((img) => (
            <div key={img.id} className="relative group">
              <ImageThumbnail
                imageId={img.id}
                alt={img.originalName}
                className="h-20 w-auto max-w-40 object-cover rounded"
                onClick={() => setFullscreenId(img.id)}
              />
              <button
                type="button"
                onClick={() => deleteMutation.mutate(img.id)}
                className="absolute -top-1.5 -right-1.5 w-4 h-4 flex items-center justify-center
                  bg-danger text-white rounded-full opacity-0 group-hover:opacity-100
                  transition-opacity text-[10px] leading-none"
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      )}

      {!hideUploader && (
        <ImageUploader
          {...(entityType === "task" ? { taskId: entityId } : { eventId: entityId })}
        />
      )}

      {fullscreenId && (
        <ImageLightbox imageId={fullscreenId} onClose={() => setFullscreenId(null)} />
      )}
    </div>
  );
}
